module.exports = __webpack_public_path__ + "assets/img/6aefc214c4f689f872a3d0823e2d07fd.svg";